import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Tag, Row, Col, Button, Modal, Form, Input, Space } from 'antd';
import { MobileOutlined, MailOutlined } from '@ant-design/icons';
import moment from 'moment';

import * as Config from '../../appConfig';

const EmployeeHeader = ({ employee, ability, onResetEmployeeIdSubmit }) => {
  // const getActiveIdCard = (idCards) => {
  //   const found = idCards.find((i) => i.isActive);
  //   return found
  //     ? { cardNumber: found.cardNumber, cardExpDate: found.cardExpDate }
  //     : null;
  // };
  // const activeCard = getActiveIdCard(employee.idCards);

  const [showResetEmpIdModal, setShowResetEmpIdModal] = useState(false);

  return (
    <>
      <Row>
        {/* <Col xs={0} md={4} lg={3}>
        <Avatar size={96}>RG</Avatar>
      </Col> */}
        <Col xs={24} md={18} lg={18} style={{ letterSpacing: '.5pt' }}>
          <h2 style={{ marginBottom: '.5rem' }}>
            {employee.first_name} {employee.last_name} [{employee.emp_id}]
            {ability.toResetEmployeeId && (
              <Button
                type="link"
                onClick={() => {
                  setShowResetEmpIdModal(true);
                }}
              >
                Reset Employee Id
              </Button>
            )}
          </h2>
          <div>
            <strong>D.O.J:</strong>{' '}
            {moment(employee.date_of_joining).format(Config.DATE_FORMAT)} |{' '}
            {employee.status === 1 ? (
              <Tag color="#87d068">Active</Tag>
            ) : (
              <Tag color="grey">In-Active</Tag>
            )}
          </div>
          {employee.identityCard && (
            <div>
              <strong>ID:</strong> {employee.identityCard.card_number} /{' '}
              <strong>Exp. Date:</strong>{' '}
              {moment(employee.identityCard.card_validity_end).format(
                Config.DATE_FORMAT
              )}
            </div>
          )}
          <div>
            {employee.location.region.name} / {employee.location.name}
          </div>
          {employee.designation && <div>{employee.designation.name}</div>}
        </Col>
        <Col xs={24} md={6}>
          {employee.contact && (
            <div align="right">
              {employee.contact.phone_1 && (
                <div align="right">
                  {employee.contact.phone_1}{' '}
                  <MobileOutlined style={{ fontSize: '1rem' }} />
                </div>
              )}
              {employee.contact.phone_2 && (
                <div align="right">
                  {employee.contact.phone_2}{' '}
                  <MobileOutlined style={{ fontSize: '1rem' }} />
                </div>
              )}
              {employee.contact.email && (
                <div align="right">
                  {employee.contact.email}{' '}
                  <MailOutlined style={{ fontSize: '1rem' }} />
                </div>
              )}
            </div>
          )}

          {/* {[
          { type: 'phone', value: employee.contact.phone1},
          { type: 'phone', value: employee.contact.phone2 },
          { type: 'email', value: employee.contact.email },
        ].map((item) => (
          <div align="right">
            {item.value}{' '}
            {item.type === 'phone' && (
              <MobileOutlined style={{ fontSize: '1rem' }} />
            )}{' '}
            {item.type === 'email' && (
              <MailOutlined style={{ fontSize: '1rem' }} />
            )}{' '}
          </div>
        ))} */}
        </Col>
      </Row>
      {showResetEmpIdModal && (
        <Modal
          title="Reset Employee ID"
          visible={showResetEmpIdModal}
          confirmLoading={false}
          destroyOnClose={true}
          centered
          style={{ maxWidth: '700px' }}
          width="80%"
          footer={null}
          onCancel={() => setShowResetEmpIdModal(false)}
          maskClosable={false}
        >
          <Form
            layout="vertical"
            size="large"
            className="ant-form-custom"
            initialValues={{
              id: employee.id,
            }}
            onFinish={(values) =>
              onResetEmployeeIdSubmit(values, (updated) => {
                setShowResetEmpIdModal(false);
              })
            }
            style={{ marginTop: '0' }}
          >
            <Row>
              <Col xs={24}>
                <p>
                  This will update the employee id based on name and location.
                  Are you sure you want to continue?
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={24} align="right">
                <Space>
                  <Button
                    type="secondary"
                    size="middle"
                    onClick={() => setShowResetEmpIdModal(false)}
                  >
                    Cancel
                  </Button>
                  <Button type="primary" size="middle" htmlType="submit">
                    Confirm
                  </Button>
                </Space>
              </Col>
            </Row>
            <Form.Item name="id" hidden>
              <Input />
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};

EmployeeHeader.defaultProps = {};

EmployeeHeader.propTypes = {
  employee: PropTypes.object.isRequired,
};

export default EmployeeHeader;
